import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const getBackendVersion = async (force: boolean = false) => {
  let version = storage.getBackendVersion();
  if (!version || force) {
    const url = `${getFunctionBaseUrl()}/api/getVersion`;
    const response = await rest.get(url);
    version = response;
    console.log("getBackendVersion() version now:" + version + "force:" + force);
    storage.setBackendVersion(version ? version : "")
  }
  return version;
}